import { render, staticRenderFns } from "./DashboardThisMonthCard.vue?vue&type=template&id=0499b4a9&"
import script from "./DashboardThisMonthCard.vue?vue&type=script&lang=js&"
export * from "./DashboardThisMonthCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports